import { ExpertEntryTabsTypeParams } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getExpertTabs/getExpertTabsQuery.type';
import { getExpertTabsQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getExpertTabs/getExpertTabsQueryFunction';
import { getInitialVisitExpertTabsQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getExpertTabs/getInitialVisitExpertTabsQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getExpertTabsQueryOptions = (
  params: ExpertEntryTabsTypeParams,
) => {
  const queryFn = () => {
    if (params.type && params.type === 'initial') {
      return getInitialVisitExpertTabsQueryFunction(params);
    }
    return getExpertTabsQueryFunction(params);
  };
  return queryOptions({
    queryKey: ['get_expert_tabs', params],
    queryFn: () => queryFn(),
  });
};
